"use strict";

var _taggedTemplateLiteral = require("/codebuild/output/src213846038/src/github.com/rteamweb/web-marketing-ui/application/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");

var _templateObject;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RenderSocialLinks = void 0;

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var react_1 = require("@emotion/react");

var frontend_layout_1 = require("@ryerson/frontend.layout");

var frontend_navigation_1 = require("@ryerson/frontend.navigation");

var frontend_assets_1 = require("@ryerson/frontend.assets");

var StyledComponents_1 = require("../Footer/Helpers/StyledComponents");

var RenderSocialLinks = function RenderSocialLinks(color) {
  return (0, jsx_runtime_1.jsxs)(frontend_layout_1.Flex, {
    alignItems: "center",
    style: (0, react_1.css)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\t\t\theight: 50px;\n\t\t"]))),
    children: [(0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: StyledComponents_1.socialMediaIcon,
      children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        to: "https://www.facebook.com/ryersonmetals/?fref=nf",
        gatsby: false,
        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: "social-facebook",
          size: "sm",
          color: color,
          onClick: function onClick() {}
        })
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: StyledComponents_1.socialMediaIcon,
      children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        to: "https://www.instagram.com/ryersonmetals/?hl=en",
        gatsby: false,
        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: "social-instagram",
          size: "sm",
          color: color,
          onClick: function onClick() {}
        })
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: StyledComponents_1.socialMediaIcon,
      children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        to: "https://www.linkedin.com/company/ryerson?trk=top_nav_home",
        gatsby: false,
        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: "social-linked-in",
          size: "sm",
          color: color,
          onClick: function onClick() {}
        })
      })
    }), (0, jsx_runtime_1.jsx)(frontend_layout_1.FlexItem, {
      style: StyledComponents_1.socialMediaIcon,
      children: (0, jsx_runtime_1.jsx)(frontend_navigation_1.Link, {
        to: "https://www.youtube.com/channel/UCAjLhGiGaSBbTOwq52rZNAw",
        gatsby: false,
        children: (0, jsx_runtime_1.jsx)(frontend_assets_1.Icon, {
          icon: "social-youtube",
          size: "sm",
          color: color,
          onClick: function onClick() {}
        })
      })
    })]
  });
};

exports.RenderSocialLinks = RenderSocialLinks;